import Vue from 'vue'
import dayjs from 'dayjs'
import get from 'lodash-es/get'

Vue.filter('date', value => value ? dayjs(String(value)).format('D MMM YYYY') : '')
Vue.filter('datetime', value => value ? dayjs(String(value)).format('D MMM YYYY, h:mm A') : '')
Vue.filter('currency', value => {
  let n = 2
  let x = 3
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')'
  return '£ ' + value.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,')
})

Vue.filter('number', number => {
  number = parseInt(number, 10)
  return isNaN(number) || !isFinite(number) ? 0 : number
})
